module.exports = __webpack_public_path__ + "static/media/asset.5a51ec88.svg";